import { render } from "./ProductUpdatePhoto.vue?vue&type=template&id=814793dc&scoped=true"
import script from "./ProductUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./ProductUpdatePhoto.vue?vue&type=script&lang=js"

import "./ProductUpdatePhoto.vue?vue&type=style&index=0&id=814793dc&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814793dc"]])

export default __exports__